import Accordion from './Accordion';
import AvatarGrid from './AvatarGrid';
import Banner from './Banner';
import BlockFunnel from './BlockFunnel';
import Button from './Button';
import Carousel from './Carousel';
import Checklist from './Checklist';
import ColumnBlock from './ColumnBlock';
import Cta from './Cta';
import Embed from './Embed';
import GenericCTA from './GenericCTA';
import GenericCTASmall from './GenericCTASmall';
import HeroCTA from './HeroCTA';
import HeroFunnel from './HeroFunnel';
import IconRow from './IconRow';
import Image from './Image';
import ImageGrid from './ImageGrid';
import ImageRow from './ImageRow';
import ImageText from './ImageText';
import Infobox from './Infobox';
import QuickDetails from './QuickDetails';
import DoctorList from './RefugeeDoctors';
import RichText from './RichText';
import Table from './Table';
import Testimonial from './Testimonial';
import Timeline from './Timeline';
import Treatments from './Treatments';
import Youtube from './Youtube';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const blockMapping: Record<string, (props: any) => JSX.Element | null> =
  {
    richText: RichText,
    RichText,
    ContentTypeRichText: RichText,
    imageText: ImageText,
    ImageText,
    columnBlock3: ColumnBlock,
    ColumnBlock3: ColumnBlock,
    infoboxBlock: Infobox,
    InfoboxBlock: Infobox,
    accordionBlock: Accordion,
    AccordionBlock: Accordion,
    blockQuickDetails: QuickDetails,
    BlockQuickDetails: QuickDetails,
    blockImage: Image,
    BlockImage: Image,
    blockImageRow: ImageRow,
    BlockImageRow: ImageRow,
    blockYoutube: Youtube,
    BlockYoutube: Youtube,
    blockImageGrid: ImageGrid,
    BlockImageGrid: ImageGrid,
    blockAvatargrid: AvatarGrid,
    BlockAvatargrid: AvatarGrid,
    blockHeroCta: HeroCTA,
    BlockHeroCta: HeroCTA,
    blockIconRow: IconRow,
    BlockIconRow: IconRow,
    blockHeroFunnel: HeroFunnel,
    BlockHeroFunnel: HeroFunnel,
    blockButton: Button,
    BlockButton: Button,
    blockGenericCta: GenericCTA,
    BlockGenericCta: GenericCTA,
    blockGenericCtaSmall: GenericCTASmall,
    blockCta: Cta,
    BlockCta: Cta,
    blockBanner: Banner,
    BlockBanner: Banner,
    blockFunnel: BlockFunnel,
    BlockFunnel,
    blockTable: Table,
    BlockTable: Table,
    blockCarousel: Carousel,
    BlockCarousel: Carousel,
    blockTimeline: Timeline,
    BlockTimeline: Timeline,
    blockTreatments: Treatments,
    BlockTreatments: Treatments,
    blockChecklist: Checklist,
    BlockChecklist: Checklist,
    blockEmbed: Embed,
    BlockEmbed: Embed,
    blockTestimonial: Testimonial,
    BlockTestimonial: Testimonial,
    blockUkraineRefugeeDoctorsList: DoctorList,
    BlockUkraineRefugeeDoctorsList: DoctorList,
  };
